/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ApolloError, gql, useMutation } from "@apollo/client";

import { useErrorsOrSuccessHandler } from "graphql/errorHandlers";
import { ERROR_FRAGMENT, ErrorFragment } from "graphql/fragments";

const SEND_INVOICE_VIA_EHF = gql`
  mutation ($id: ID!) {
    sendInvoiceViaEhf(input: { id: $id }) {
      errors {
        ...ErrorFragment
      }
    }
  }
  ${ERROR_FRAGMENT}
`;

interface Payload {
  errors: ErrorFragment[];
}

interface SendInvoiceViaEhfMutation {
  sendInvoiceViaEhf: Payload | null;
}

export const useSendInvoiceViaEhfMutation = () => {
  const handleErrors = useErrorsOrSuccessHandler(
    "success.sentInvoiceViaEhf",
    "Invoice was sent successfully via ehf"
  );
  // Values for extraction
  // t("common:success.sentInvoiceViaEhf", "Invoice was sent successfully via ehf")

  const [mutation, { data, loading, called }] = useMutation<
    SendInvoiceViaEhfMutation,
    { id: string }
  >(SEND_INVOICE_VIA_EHF);

  const sendInvoiceViaEhf = (id: string, onSuccess?: () => void) =>
    mutation({ variables: { id } })
      .then(({ data, errors }) => {
        const dataErrors = data?.sendInvoiceViaEhf?.errors ?? [];

        handleErrors({
          dataErrors,
          graphqlErrors: errors,
          onSuccess: () => onSuccess && onSuccess(),
          onRetry: () => sendInvoiceViaEhf(id, onSuccess),
        });
      })
      .catch((_error: ApolloError) => null);

  return {
    sendInvoiceViaEhf,
    isLoading: loading,
    called,
    errors: data?.sendInvoiceViaEhf?.errors ?? [],
  };
};
